import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';

/** ISO для разделителей дней: приоритет серверному времени, иначе стабильный fallback от предыдущего элемента. */
export function resolveTrackerMessageTimelineIso(
  message: TrackerChatMessage,
  prevResolvedIso: string
): string {
  const raw = message.metadata?.messageCreatedAt;
  if (typeof raw === 'string' && raw.trim()) return raw.trim();
  return prevResolvedIso;
}
